module.exports = __webpack_public_path__ + "static/media/face-2.38767dae.jpg";